<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-header-title">
          {{ $t('Store information') }}
        </h4>
      </div>
      <div class="index-iner-table">
        <div class="table-responsive">
          <table class="table table-sm table-nowrap card-table table-hover">
            <thead>
              <tr>
                <th class="">
                  <span class="text-muted">
                    {{ $t('Store name') }}
                  </span>
                </th>
                <th class="">
                  <span class="text-muted">
                    {{ $t('Quantity') }}
                  </span>
                </th>
                <th class="">
                  <span class="text-muted">
                    {{ $t('Less amount') }}
                  </span>
                </th>
                <th class="">
                  <span class="text-muted">
                    {{ $t('Attention') }}
                  </span>
                </th>
              </tr>
            </thead>
            <tbody class="list">
              <tr class="" v-for="(item, index) in items">
                <td class="orders-order">
                  <strong class="mobile-title">{{ $t('storeName') }}</strong>
                  <router-link :to="'/stores/' + itemstore_id">{{ item.store.name }}</router-link>
                </td>
                <td class="orders-order">
                  <strong class="mobile-title">{{ $t('Quantity') }}</strong>
                  {{ item.quantity }}
                </td>
                <td class="orders-order">
                  <strong class="mobile-title">{{ $t('Less amount') }}</strong>
                  {{ item.min_quantity }}
                </td>
                <td class="orders-order">
                  <strong class="mobile-title">{{ $t('Attention') }}</strong>
                  {{
                    item.quantity <= item.min_quantity
                      ? $t('Below the lower bound or zero')
                      : $t('Available')
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import indexTable from '@/elements/index/indexTable.vue'
export default {
  components: {
    indexTable
  },
  props: ['items']
}
</script>
